import { Form, type FormInstance } from 'antd';
import { useState } from 'react';
import type { ProdutoAdicionalBody } from '@/features/produto-adicional/types/ProdutoAdicional';
import type { ProdutoAdicionalItemBody } from '@/features/produto-adicional/types/ProdutoAdicionalItem';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import { useDialog } from '@/std/dialog/useDialog';
import { ProdutoTabAdicionalInfo } from './ProdutoTabAdicionalInfo';
import { ProdutoTabAdicionalList } from './ProdutoTabAdicionalList';
import { ProdutoTabAdicionalModal } from './ProdutoTabAdicionalModal';
import { ProdutoTabAdicionarHeader } from './ProdutoTabAdicionarHeader';

export function ProdutoTabAdicional({
    form,
    setFormDirty,
}: {
    form: FormInstance<FormProdutoValues>;
    setFormDirty: (dirty: boolean) => void;
}) {
    const [adicional, setAdicional] = useState<ProdutoAdicionalBody | null>(null);

    const dialog = useDialog<ProdutoAdicionalItemBody>();

    const adicionarAdicionalItem = (adicional: ProdutoAdicionalBody): void => {
        setAdicional(adicional);
        dialog.actions.add();
    };

    const editarAdicionalItem = (
        adicional: ProdutoAdicionalBody,
        item: ProdutoAdicionalItemBody,
    ): void => {
        setAdicional(adicional);
        dialog.actions.edit(item);
    };

    const onCloseModal = (): void => {
        setAdicional(null);
        dialog.actions.close();
    };

    return (
        <div className='flex flex-col gap-4'>
            <Form.Item hidden name='adicional' />

            <ProdutoTabAdicionalModal
                adicional={adicional}
                dialog={dialog}
                formProduto={form}
                onClose={onCloseModal}
                setFormDirty={setFormDirty}
            />

            <ProdutoTabAdicionalInfo />

            <ProdutoTabAdicionarHeader
                adicional={adicional}
                adicionar={adicionarAdicionalItem}
                setAdicional={setAdicional}
            />

            <ProdutoTabAdicionalList
                adicionarAdicionalItem={adicionarAdicionalItem}
                editarAdicionalItem={editarAdicionalItem}
                form={form}
                setFormDirty={setFormDirty}
            />
        </div>
    );
}
